<template>
  <div class="phrase-overlay" :style="drawer ? 'z-index:1000' : 'z-index:-30000; opacity:0'" v-if="drawer">
    <transition name="fade">
      <div class="tag-dialog">
        <div class="newmessage-title">
          <div class="flex-row">
            <div>カスタマイズタグを管理</div>
            <div style="font-weight:700;">({{ tag_num }}件)</div>
          </div>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="closeDrawer()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="tag-dialog-title">
          <div class="flex-row">
            <div>タグの編集、削除を行えます。</div>
          </div>
          <div class="flex-space"></div>
          <el-dropdown trigger="click" style="margin-left: 20px;">
            <el-button type="default" size="mini" class="report-media-sort-button" style="width:auto" :disabled="tag_list.length == 0">
              {{ sort_description }}
              <font-awesome-icon icon="caret-down" style="margin-left:5px" />
            </el-button>
            <el-dropdown-menu slot="dropdown" style="z-index:50000">
              <el-dropdown-item @click.native="sortBy('created_at', 'desc', 'タグ作成日が新しい順')">タグ作成日が新しい順</el-dropdown-item>
              <el-dropdown-item @click.native="sortBy('created_at', 'asc', 'タグ作成日が古い順')">タグ作成日が古い順</el-dropdown-item>
              <el-dropdown-item @click.native="sortBy('added_num', 'desc', 'タグ付け人数が多い順')">タグ付け人数が多い順</el-dropdown-item>
              <el-dropdown-item @click.native="sortBy('added_num', 'asc', 'タグ付け人数が少ない順')">タグ付け人数が少ない順</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="tag-dialog-box" v-loading="loading" v-if="loading"></div>
        <div class="tag-dialog-box" v-else-if="tag_list.length >= 1">
            <div class="customize-tag-suggest-box admin" v-for="(tag, index) in tag_list" :key="tag.tag_id">
              <div v-if="edit_index == index">
                <customizeTagDrawerInput :tag="tag" :index="index" @editTag="editTag" @closeEditTag="closeEditTag" />
              </div>
              <div class="customize-tag small" :class="tag.tag_color" v-else>{{ tag.tag_name }}</div>
              <div class="flex-space"></div>
              <div class="tag-dialog-button-wrap" :class="edit_index == index || edit_color_index == index ? 'visible' : ''">
                <customizeTagDrawerDropdown :tag="tag" :index="index" :edit_color_index.sync="edit_color_index" @editTag="editTag" />
                <div class="tag-dialog-button" @click="openEditTag(tag.tag_id, index)"><font-awesome-icon :icon="['far', 'pen']" /></div>
                <div class="tag-dialog-button" @click="deleteTag(tag.tag_id, tag.added_num)"><font-awesome-icon :icon="['far', 'trash-alt']" /></div>
              </div>
              <div style="margin-left:15px">
                <span>{{ tag.added_num }}</span>
              </div>
            </div>
          <!-- </draggable> -->
          
        </div>
        <div class="tag-dialog-box" v-else>
          <div class="no-customize-tag">
            <img src="../../assets/search_image.png" style="opacity:0.5" alt />
            <div style="font-size:14px; font-weight:700; margin-bottom:10px;">カスタマイズタグがありません</div>
            <div style="font-size:11px">タグを追加してインフルエンサーを効率的に管理しましょう</div>
          </div>
        </div>

        <div class="list-create-footer">
          <el-input size="small" v-model="new_tag" placeholder="新しいカスタマイズタグを追加" style="width:200px;margin-right:10px" @change="addTag()"></el-input>
          <el-button size="small" type="primary" @click="addTag()" :disabled="!new_tag">タグを追加</el-button>
          <div class="flex-space"></div>
          <el-button size="small" @click="closeDrawer()">閉じる</el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import customizeTagDrawerDropdown from "./customize_tag_drawer_dropdown.vue";
import customizeTagDrawerInput from "./customize_tag_drawer_input.vue";

const root = process.env.VUE_APP_API;
const loadTagAPI = root + "/api/note/load_tag";
const deleteTagAPI = root + "/api/note/delete_tag";
const editTagAPI = root + "/api/note/edit_tag";
const addTagAPI = root + "/api/note/add_tag";

export default {
  name: "customizeTagDrawer",
  props: {
    drawer: { type: Boolean, default: false },
  },
  components: {
    customizeTagDrawerDropdown,
    customizeTagDrawerInput,
  },
  data() {
    return {
      loading: false,
      tag_list: [],
      tag_num: 0,
      edit_index: -1,
      edit_color_index: -1,
      sort_key: "created_at",
      sort_order: "desc",
      sort_description: "タグ作成日が新しい順",
      color_list: [
        { color: "grey", name: "グレー" },
        { color: "red", name: "レッド" },
        { color: "purple", name: "パープル" },
        { color: "blue", name: "ブルー" },
        { color: "green", name: "グリーン" },
        { color: "yellow", name: "イエロー" },
      ],
      new_tag: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.loadTag();
  },
  methods: {
    loadTag() {
      this.loading = true;
      this.axios
        .get(loadTagAPI, {
          params: {
            token: this.token,
            sort_key: this.sort_key,
            sort_order: this.sort_order,
            all: 1,
          },
        })
        .then((response) => {
          this.tag_list = response.data.tag_list;
          this.tag_num = response.data.tag_num;
          setTimeout(() => {
            this.loading = false;
          }, 300);
        })
        .catch(() => {});
    },
    sortBy(sort_key, sort_order, description) {
      this.tag_list = [];
      this.tag_num = 0;
      this.sort_description = description;
      this.sort_key = sort_key;
      this.sort_order = sort_order;
      this.loadTag();
    },
    openEditColorDropdown(boolean, index) {
      if (boolean) {
        this.edit_color_index = index;
      } else {
        this.edit_color_index = -1;
      }
    },
    openEditTag(tag_id, index) {
      this.edit_index = index;
      setTimeout(() => {
        document.getElementById(tag_id).focus();
      }, 100);
    },
    closeEditTag() {
      this.edit_index = -1;
    },
    editTag(type, tag_id, value, index) {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("tag_id", tag_id);
      params.append("value", value);
      params.append("type", type);
      this.axios
        .post(editTagAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: type == "name" ? "タグ名を変更しました" : type == "color" ? "タグのカラーを変更しました" : "",
            });
            this.edit_index = -1;
            this.edit_color_index = -1;
            this.$emit("updateReactive", type, tag_id, value);
            if (type == "color") this.tag_list[index].tag_color = value;
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message,
            }); 
          }
        })
        .catch(() => {});
    },
    deleteTag(tag_id, added_num) {
      this.$confirm(added_num + "名のインフルエンサーにこのタグが追加されています。<br/>※この操作は取り消せません。", "カスタマイズタグを削除しますか？", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "削除",
        confirmButtonClass: "danger",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("tag_id", tag_id);
          params.append("delete_type", "tag");
          this.axios
            .post(deleteTagAPI, params)
            .then(() => {
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "タグを削除しました",
              });
              this.loadTag();
              this.$emit("updateReactive", "delete", tag_id);
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    addTag() {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("tag_name", this.new_tag);
      this.axios
        .post(addTagAPI, params)
        .then((response) => {
          if (response.data.status == "OK") {
            this.new_tag = "";
            this.loadTag();
          } else {
            this.$message({
              type: "error",
              offset: 7,
              showClose: true,
              message: response.data.message,
            }); 
          }
        });
    },
    closeDrawer() {
      this.$emit("closeDrawer");
    },
  },
  watch: {
    drawer() {
      if (this.drawer) {
        this.new_tag = "";
        this.sort_description = "タグ作成日が新しい順";
        this.sort_key = "created_at";
        this.sort_order = "desc";
        this.loadTag();
      }
    },
  },
};
</script>
